var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.video, function (item, index) {
      return _c("div", {
        key: index,
        staticClass: "playerVideo",
        attrs: { id: `player${item.url}` },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resource/videoResource.vue?vue&type=template&id=5ab7e110&scoped=true&
// module id = null
// module chunks = 